import React from "react";
import ReactDOM from "react-dom";
import { appInsights } from "./services/telemetry.service";
import moment from "moment-timezone";
import ResizeObserver from "resize-observer-polyfill";
import { initPowFeatures } from "./services/powFeatures.service";
import { ReactRouter } from "./router/reactRouter";
import { BrowserRouter } from "react-router-dom";
import { StateProvider } from "./globalState/StateProvider";
window.ResizeObserver = window.ResizeObserver || ResizeObserver; // set the observer globally before importing app

moment.tz.setDefault("UTC");

declare global {
	interface Window {
		ResizeObserver: any;
		pow: {
			appInsightsKey: string;
			initReactPage: (pageName: string) => void;
		};
	}
}

window.pow = window.pow || {};

window.pow.initReactPage = (pageName: string, powFeatures: string[] = []) => {
	initPowFeatures(powFeatures);

	appInsights.trackTrace({
		message: `Initialized ${pageName} React page.`,
		properties: { url: window.location.href, powFeatures },
	});

	ReactDOM.render(
		<StateProvider>
			<BrowserRouter>
				<ReactRouter />
			</BrowserRouter>
		</StateProvider>,
		document.getElementById("reactRootElement"),
	);
};
